import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API } from '../../constants/api-endpoints';
import { SessaoOperacao, SessaoAtiva, SessaoAtivaDetalhada } from './operacao-sessao.model';

// Cliente HTTP dos endpoints de sessao de operacao. Sem logica de
// heartbeat/beforeunload — isso e responsabilidade do
// SessaoHeartbeatService, para que este service permaneca simples e
// testavel.
@Injectable({
  providedIn: 'root'
})
export class OperacaoSessaoService {
  constructor(private http: HttpClient) {}

  // POST /api/operacoes/sessao/{idEmpreendimento}
  // 200 -> sessao aberta/reaproveitada
  // 409 -> em uso por outro (o componente inspeciona o body do erro)
  iniciar(idEmpreendimento: number): Observable<SessaoOperacao> {
    return this.http.post<SessaoOperacao>(
      API.operacoesSessao.iniciar(idEmpreendimento),
      {}
    );
  }

  // POST /api/operacoes/sessao/{guid}/heartbeat
  // 204 -> renovada
  // 404 -> sessao perdida (o SessaoHeartbeatService trata como logout forcado)
  heartbeat(identificadorSessao: string): Observable<void> {
    return this.http.post<void>(
      API.operacoesSessao.heartbeat(identificadorSessao),
      {}
    );
  }

  // DELETE /api/operacoes/sessao/{guid}
  // Encerramento manual (usuario clicou em "sair da operacao" ou trocou de aba).
  encerrar(identificadorSessao: string): Observable<void> {
    return this.http.delete<void>(
      API.operacoesSessao.encerrar(identificadorSessao)
    );
  }

  // POST /api/operacoes/sessao/encerrar-todas
  // Chamado antes do msalService.logoutRedirect() no AuthService.
  encerrarTodasDoUsuario(): Observable<{ quantidadeEncerrada: number }> {
    return this.http.post<{ quantidadeEncerrada: number }>(
      API.operacoesSessao.encerrarTodas,
      {}
    );
  }

  // GET /api/operacoes/sessao/ativas
  // Grid da tela "Busca de empreendimento" cruza com a lista de
  // empreendimentos para exibir o avatar "em uso por".
  listarAtivas(): Observable<SessaoAtiva[]> {
    return this.http.get<SessaoAtiva[]>(API.operacoesSessao.ativas);
  }

  // GET /api/operacoes/sessao/ativas/detalhado
  // Usado pela tela ADMINISTRATIVA "Sessoes de operacao" — retorna dados
  // completos (empreendimento, investidor, email, ultima atividade).
  // Restrito ao perfil GerenciarAcesso + Visualizar no backend.
  listarAtivasDetalhado(): Observable<SessaoAtivaDetalhada[]> {
    return this.http.get<SessaoAtivaDetalhada[]>(
      API.operacoesSessao.ativasDetalhado
    );
  }

  // POST /api/operacoes/sessao/{guid}/forcar
  // Liberacao FORCADA por um administrador — encerra a sessao de outro
  // usuario. Idempotente. Restrito ao perfil GerenciarAcesso + Alterar
  // no backend.
  forcarEncerramento(identificadorSessao: string): Observable<void> {
    return this.http.post<void>(
      API.operacoesSessao.forcar(identificadorSessao),
      {}
    );
  }
}
